import script from "./LayoutViewSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutViewSwitch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__